module.exports = __webpack_public_path__ + "img/Emily-Stone.e1e0ed62.png";